import { useMemo } from 'react';

export const useSxStyles = () => {
  return useMemo(() => {
    const menuWidth = '260px';

    return {
      menuButton: {
        width: menuWidth,
        textTransform: 'none',
        justifyContent: 'space-between',
      },
      menuList: {
        width: menuWidth,
      },
    };
  }, []);
};
